/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Text, BackgroundPanel, Button } from "vr-react-components";
import BarTooltip from "../../../widgets/BarWidget/BarWidgetTooltip";
import CenterChart from "../../../components/CenterChart";
import RightPanelDesktop from "./RightPanelDesktop";
import LeftPanelDesktop from "./LeftPanelDesktop";
import { handleGoToTopologyRoom } from "../../../handlers/TopologyRoomHandlers";
import { handleGoToDelayAnalysisRoom } from "../../../handlers/DelayAnalysisRoomHandlers";
import { JOB_ROOM, TOPOLOGY_ROOM } from "../../RoomNameConstants";

const DesktopRoom = () => {
    const title = "Job Room";
    const selectedJob = useSelector((state) => state[JOB_ROOM].selectedJob)
    const canModify = useSelector((state) => state.private.device.canModify);
    const graphData = useSelector((state)=> state[TOPOLOGY_ROOM].graph.data)

    const isLoading = graphData?.links?.length === 0 && graphData?.nodes?.length === 0;

    return (
        <a-entity class="Job Room">
            <Text align="left" position="-2.65 3 -1.8" width="2" size="p4" text={title} />
            <a-entity id="right-panel" position="2 1.7 -1.8">
                <RightPanelDesktop width={1.6} height={2.3} />
            </a-entity>
            <a-entity id="left-panel" position="-2 1.7 -1.8">
                <LeftPanelDesktop width={1.6} height={2.3} />
            </a-entity>
            <BackgroundPanel position="0 2.6 -1.8" width={2.2} height={0.5}>
                <Text
                    text="3D Data Visualization"
                    width={2}
                    sizeDecimal={20}
                    position="-1.05 0.22 0"
                    baseline="top"
                />
                <BarTooltip
                    width={1.6}
                    height={0.35}
                    stateName="centerGraph"
                    position="-0.25 -0.05 0.001"
                    backgroundColor="#262626"
                />
                <BackgroundPanel
                    width={0.45}
                    height={0.35}
                    position="0.825 -0.05 0.001"
                    backgroundColor="#262626"
                >
                    <Button
                        aframeClasses={canModify ? "collidable" : ""}
                        height={0.35 * 0.25}
                        width={0.4}
                        position={`0 ${-0.35 * 0.2} 0.001`}
                        text={"Jobstream view"}
                        type={Button.constants.primary}
                        onClickHandler={() => {
                            handleGoToTopologyRoom(selectedJob)
                        }}
                        textSizeDecimal={40}
                        loading={isLoading}
                    />
                    <Button
                        aframeClasses={canModify ? "collidable" : ""}
                        height={0.35 * 0.25}
                        width={0.4}
                        position={`0 ${0.35 * 0.2} 0.001`}
                        text={"Delay Analysis"}
                        type={Button.constants.primary}
                        onClickHandler={() => {
                            handleGoToDelayAnalysisRoom(selectedJob)
                        }}
                        textSizeDecimal={40}
                    />
                </BackgroundPanel>
            </BackgroundPanel>
            <a-entity position="0 0.8 -3">
                <CenterChart width={3.25} height={2} depth={2} />
            </a-entity>
        </a-entity>
    );
};

export default DesktopRoom